import { connect } from 'react-redux';
import UpperProductSpecific from './upperProductSpecific';

const mapStateToProps = ({ detailsPage }) => ({
  content:
    (detailsPage.loadedProduct.contentSlotsHtml &&
      detailsPage.loadedProduct.contentSlotsHtml.UpperProductSpecificContent) ||
    '',
});

export default connect(mapStateToProps)(UpperProductSpecific);
